import React from 'react'

function TenderTextKKSLDM() {
  return (
    <embed src="\pdfs\DAT2.2.1.2_KKS-5-LD-M_Kontakt-Kuehldeckensystem_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextKKSLDM